module.exports = __webpack_public_path__ + "img/result1.67d4db80.png";